import React, { Component } from 'react';
import { Context } from '~/UI/Modal/Modal';

interface Props {
	children: React.ReactNode;
}

export default class ModalHeader extends Component<Props> {
	render() {
		const { children } = this.props;

		return <Context.Consumer>{(styles) => <div className={styles.header}>{children}</div>}</Context.Consumer>;
	}
}
